import React from 'react';
import styles from './AddLessonButton.module.scss';
import IconPlus from '../../../../assets/icons/plus_circle.svg?react';
import { useCreateLessonMutation } from '../../../../api/graphql-codegen';
import { useEditUnit } from '../edit/useEditUnit';
import Spinner from '@components/spinner/Spinner';
import { logger } from '../../../../utils/logger';

type Props = {
  unitId: string;
  onCreated: () => void;
};

function AddLessonButton(props: Props) {
  const { unitId, onCreated } = props;

  const { setLesson, setSelectionLevel, setContent } = useEditUnit();

  const [create, { loading }] = useCreateLessonMutation({
    onCompleted(res) {
      const lesson = res.createLesson;
      if (lesson) {
        setSelectionLevel('Lesson');
        setLesson(lesson);
        setContent(undefined);
      }
    },
    update() {
      onCreated();
    },
    onError(e) {
      logger.debug(`[e]`, e);
      alert('Something went wrong.');
    }
  });

  const handleCreate = () => {
    create({
      variables: {
        input: { id: unitId },
      }
    });
  };

  return (
    <button disabled={loading} onClick={handleCreate} className={styles.wrapper}>
      <div className={styles.content}>
        {loading ? <Spinner width={20} height={20} /> : <IconPlus className={styles.icon}/>}
        <div className={styles.title}>Add lesson</div>
      </div>
    </button>
  );
}

export default AddLessonButton;
